<template>
  <div>
    <!-- <PreloaderPage /> -->
    <!-- <RegulationBar class="desktop"/> -->
    <!-- <transition name="fade"> // modal custom para avisos 
      <NewModal :isVisible="openLangModal2" @close="closeModal2" />
    </transition> -->

    <!-- <Navbar-ja v-if="locale === 'ja'" /> -->
    <Navbar />

    <!-- <NavbarMobile-ja v-if="locale === 'ja'" /> -->
    <NavbarMobile />

    <NuxtPage />

   <!--  <Footer-ja v-if="locale === 'ja'"/> -->
    <Footer />
    <Disclaimer />
  </div>
</template>

<script setup lang="ts">
import { useHead, useRuntimeConfig, useRoute, useI18n, usePageSchema, useRouter, ref, computed, onMounted } from "#imports";
import { shouldNoIndexRoute } from '~/utils/languageConfig.js';
import NewModal from "~/components/modal-new.vue";
import Disclaimer from "~/components/Disclaimer.vue";

const { t, locale, locales, defaultLocale } = useI18n();
const route = useRoute();
const schema = usePageSchema();

const baseUrl = useRuntimeConfig().public.siteUrl;

const supportedLocales = computed(() => {
  const codes = (locales.value || [])
    .map((item: any) => (typeof item === 'string' ? item : item.code))
    .filter(Boolean);

  if (!codes.includes(defaultLocale)) {
    codes.unshift(defaultLocale);
  }
  return codes;
});

const canonicalPath = computed(() => {
  const currentPath = route.path;
  const localePrefix = `/${locale.value}`;

  let pathWithoutLocale = currentPath.startsWith(localePrefix)
    ? currentPath.slice(localePrefix.length)
    : currentPath;

  if (!pathWithoutLocale.startsWith('/')) {
    pathWithoutLocale = '/' + pathWithoutLocale;
  }

  return pathWithoutLocale;
});

useHead(() => {
  const path = canonicalPath.value; 
  
  const currentCanonicalUrl = `${baseUrl}/${locale.value}${path}`;
  const defaultLangUrl = `${baseUrl}/${defaultLocale}${path}`;

  const linkTags = [
    { key: 'icon', rel: 'icon', type: 'image/x-icon', href: '/favicon.svg' },
    { key: 'canonical', rel: 'canonical', href: currentCanonicalUrl },
    { key: 'hreflang-x-default', rel: 'alternate', hreflang: 'x-default', href: defaultLangUrl },
    ...supportedLocales.value.map((code: string) => ({
      key: `hreflang-${code}`,
      rel: 'alternate',
      hreflang: code,
      href: `${baseUrl}/${code}${path}`,
    })),
  ];

  // Metatags
  const metaTags: Array<Record<string, string>> = [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { property: 'og:site_name', content: 'Tradeview Europe' },
    { property: 'og:image', content: `${baseUrl}/images/seo/01Home.jpg` },
    { property: 'og:image:width', content: '2500' },
    { property: 'og:image:height', content: '1309' },
    { property: 'og:type', content: 'website' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:site', content: '@Tradeview_' },
    { name: 'twitter:creator', content: '@Tradeview_' },
    { name: 'twitter:image', content: `${baseUrl}/images/seo/01Home.jpg` },
    { name: 'description', content: t('seo.home.description') },
    { property: 'og:url', content: currentCanonicalUrl },
  ];

  if (shouldNoIndexRoute(route.path)) {
    metaTags.push({
      name: 'robots',
      content: 'noindex, nofollow',
    });
  }

  return {
    title: t('seo.home.title'),
    htmlAttrs: { lang: locale.value },
    meta: metaTags,
    link: linkTags,
    script: schema.value['@graph'].length ? [
      {
        key: 'ld-json',
        type: 'application/ld+json',
        innerHTML: JSON.stringify(schema.value),
      },
    ] : [],
  };
});

// Lógica del modal
const openLangModal2 = ref(false);

onMounted(() => {
  const modalHasBeenClosed = localStorage.getItem('hasClosedLangModal');
  if (!modalHasBeenClosed) {
    openLangModal2.value = true;
  }
});

const closeModal2 = () => {
  openLangModal2.value = false;
  localStorage.setItem('hasClosedLangModal', 'true');
};

// Configuración del scroll en el router
const router = useRouter();
router.options.scrollBehavior = (to: any, from: any, savedPosition: any) => {
  if (savedPosition) {
    return savedPosition;
  }
  if (to.hash) {
    return { el: to.hash, behavior: 'smooth' };
  }
  return { top: 0, behavior: 'smooth' };
};
</script>
